import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { BoldPipe } from '@app/pipes/bold.pipe';
import { selectAuthUserEmail } from '@app/reducers/auth/auth.selectors';
import { EmailVerificationService } from '@app/services/email-verification.service';
import { HubSpotService } from '@app/startup/hub-spot.service';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { mgcIconCloseRegular } from '@sb/mgc-icons/mgcIcon-close_regular.icon';
import { AnchorButtonComponent, ButtonComponent, IconButtonComponent } from '@sb/ui/button';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import { clsx } from 'clsx';
import { CookieService } from 'ngx-cookie-service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'verification-banner',
  templateUrl: './verification-banner.component.html',
  imports: [
    TranslatePipe,
    BoldPipe,
    RouterModule,
    ButtonComponent,
    IconButtonComponent,
    IconComponent,
    AnchorButtonComponent,
  ],
  host: {
    '[class]': 'hostClass()',
  },
})
export class VerificationBannerComponent implements OnInit {
  #emailVerification = inject(EmailVerificationService);
  #store = inject(Store<AppState>);
  #cookieService = inject(CookieService);
  #hubspotService = inject(HubSpotService);
  #destroyRef = inject(DestroyRef);

  email = this.#store.selectSignal(selectAuthUserEmail);

  isChatActive = signal(false);

  #visible = signal(true);

  hostClass = computed(() =>
    clsx(
      'z-sidebar flex w-full items-center gap-md border-x-0 border-t border-b-0 border-solid border-brand-subtle bg-brand-subtle px-8 py-2.5 shadow-lg',
      {
        hidden: !this.#visible(),
      },
    ),
  );

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconCloseRegular]);
  }

  ngOnInit(): void {
    // todo: hubspot chat service should be updated so we do not need to use cookie service to know if chat is enabled or not
    // it should be a part of the service and simply be a signal or observable
    void this.#hubspotService.isChatEnabled$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((response) => {
      this.isChatActive.set(response);
    });
    this.isChatActive.set(this.#cookieService.get('hubspotChatVisible') === 'true');
  }

  resendEmail(): void {
    this.#emailVerification.sendVerificationMail();
  }

  onClose(): void {
    this.#visible.set(false);
  }
}
